<template>
    <modal
        :name="name"
        :adaptive="true"
        :scrollable="true"
        :width="width"
        :height="height"
        @before-open="beforeOpen"
        @before-close="$emit('hide')"
    >
        <div class="p-xl" :style="{height: contentHeight}">
            <button
                v-if="showHideButton"
                class="float-right text-neutral-dark hover:text-neutral-darkest"
                @click="hide"
            >
                <font-awesome-icon
                    icon="times"
                    class="text-xl"
                />
            </button>
            <div v-if="title" class="flex items-center mb-2xl">
                <h1 class="m-0 text-md">{{ title }}</h1>
            </div>

            <slot />

            <div
                v-if="! hideActionButtons"
                :class="{ 'justify-between' : showHideButton, 'justify-end' : ! showHideButton }"
                class="flex mt-2xl flex-col-reverse md:flex-row"
            >
                <button
                    v-if="showHideButton"
                    type="button"
                    class="btn is-ghost btn-lg"
                    @click="hide"
                >
                    Avbryt
                </button>
                <slot name="primary-action">
                    <button
                        type="button"
                        class="btn btn-lg is-primary mb-md md:mb-0"
                        :class="primaryButtonClass"
                        @click="$emit('save')"
                    >
                        {{ primaryButtonText }}
                    </button>
                </slot>
            </div>
        </div>
    </modal>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                default: null,
            },
            name: {
                type: String,
                required: true,
            },
            primaryButtonText: {
                type: String,
                default: 'Spara',
            },
            primaryButtonClass: {
                type: String,
                default: 'is-primary',
            },
            width: {
                type: [String, Number],
                default: 600,
            },
            height: {
                type: String,
                default: 'auto',
            },
            hideActionButtons: {
                type: Boolean,
                default: false,
            },
            showHideButton: {
                type: Boolean,
                default: true,
            },
            contentHeight: {
                type: String,
                required: false,
                default: null,
            },
        },
        methods: {
            hide() {
                this.$modal.hide(this.name);
                this.$emit('hide');
            },
            beforeOpen(event) {
                this.$emit('before-open', event);
            },
        },
    };
</script>
